import cn from 'bem-cn';

import { Skeleton, Stack } from '../../UI';

import './Slide.skeleton.scss';

const b = cn('slide-skeleton');

export const SlideSkeleton = () => {
    return (
        <Stack className={b()}>
            <Stack className={b('content')}>
                <Stack className={b('text')}>
                    <Skeleton className={b('title')} variant="rounded" />
                    <Skeleton className={b('title')} variant="rounded" width="80%" />
                    <Skeleton className={b('description')} variant="rounded" />
                    <Skeleton className={b('description')} variant="rounded" width="80%" />
                </Stack>
                <Skeleton className={b('button')} variant="rounded" />
            </Stack>
        </Stack>
    );
};
